// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_2q6rzD","ordinal":"_3VVJs0"};